module.exports = __webpack_public_path__ + "img/stoerer.df801351.png";